import { useEffect, useState } from "react";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { useGetInterwitchAccounts } from "../../../../../hooks/api/queries/useTerminals";

export const useAllBusinessConnections = () => {
  const { search, queries, setSearch } = useUrlSearch();
  const [isConnectAccount, setIsConnectAccount] = useState(false);

  const { data, isLoading: isLoadingAccounts } = useGetInterwitchAccounts({
    queries,
  });

  useEffect(() => {
    if (!search.get("terminal_type")) {
      search.set("terminal_type", "INTERSWITCH");
      setSearch(search, { replace: true });
    }
  }, []);

  return {
    isLoadingAccounts,
    businessAccounts: data?.data || [],
    terminalType: search.get("terminal_type"),
    isConnectAccount,
    setIsConnectAccount,
  };
};
